import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchCalendarEventsMonth,
  fetchCalendarEventsMonthEntityType
} from '../../store/calendar/actions'
import colors from '../../styles/colors'
import { showMessage } from 'react-native-flash-message'
export const useMonthLoadingHelper = (activeDate, entityTypeId = null) => {
  /* To go in month/year helper */
  const dispatch = useDispatch()
  const [activeMonthYear, setActiveMonthYear] = useState(null)

  const byMonthYearEntityType = useSelector((appState) => {
    return appState.calendar.byMonthYearEntityType
  })

  const byMonthYear = useSelector((appState) => {
    return appState.calendar.byMonthYear
  })

  const markedMonthYear = useMemo(() => {
    const entity = {
      key: 'entity',
      color: colors.lightGray,
      selectedDotColor: colors.lightestGray
    }
    const virtual = {
      key: 'virtual',
      color: colors.stagingRed,
      selectedDotColor: colors.lightRed
    }
    if (byMonthYear) {
      const monthYearObject = {
        ...byMonthYear[activeMonthYear?.month + '.' + activeMonthYear?.year]
      }

      if (monthYearObject) {
        Object.keys(monthYearObject).map((key) => {
          const dotsArray = [
            monthYearObject[key].marked?.entity ? entity : undefined,
            monthYearObject[key].marked?.virtual ? virtual : undefined
          ].filter((a) => a)
          monthYearObject[key] = {
            dots: dotsArray,
            selected: key === activeDate
          }
        })
      }

      return monthYearObject
    }

    return null
  }, [activeMonthYear, byMonthYear, activeDate])

  const refetchMonth = () => {
    setMonthLoading(true)
    if (entityTypeId) {
      dispatch(
        fetchCalendarEventsMonthEntityType(activeMonthYear, entityTypeId)
      ).finally(() => {
        setMonthLoading(false)
      })
    } else {
      dispatch(fetchCalendarEventsMonth(activeMonthYear))
        .catch((e) => {
          if (e.message === 'Global user should not load calendar.') {
            showMessage({
              message: 'Global user should not load calendar.',
              type: 'info',
              duration: 3000
            })
            return
          }
        })
        .finally(() => {
          setMonthLoading(false)
        })
    }
  }
  const [lastFetchedActiveMonthYear, setLastFetchedActiveMonthYear] = useState(
    null
  )
  useEffect(() => {
    if (activeMonthYear && activeMonthYear !== lastFetchedActiveMonthYear) {
      setLastFetchedActiveMonthYear(activeMonthYear)
      refetchMonth()
    }
  }, [activeMonthYear?.month, activeMonthYear?.year])

  const [byMonthYearThisEntityType, setByMonthYearThisEntityType] = useState(
    null
  )

  const [
    activeMonthYearThisEntityType,
    setActiveMonthYearThisEntityType
  ] = useState(null)

  useEffect(() => {
    if (
      entityTypeId &&
      activeMonthYear?.year &&
      byMonthYearEntityType?.[
        activeMonthYear?.month +
          '.' +
          activeMonthYear?.year +
          '.' +
          entityTypeId
      ]
    ) {
      const key =
        activeMonthYear?.month +
        '.' +
        activeMonthYear?.year +
        '.' +
        entityTypeId

      if (key === activeMonthYearThisEntityType) {
        // stop setting this data over and over.
        return
      }
      setByMonthYearThisEntityType(byMonthYearEntityType[key])
      setActiveMonthYearThisEntityType(key)
    }
  }, [
    byMonthYearEntityType,
    activeMonthYear?.month,
    activeMonthYear?.year,
    entityTypeId
  ])

  const [monthLoading, setMonthLoading] = useState(false)

  return [
    markedMonthYear,
    monthLoading,
    setActiveMonthYear,
    refetchMonth,
    byMonthYearThisEntityType
  ]
}
